require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-83-add-edit-resources.json") })
        }
      }, "path---article-83-add-edit-resources");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-83-add-edit-resources!./.cache/json/article-83-add-edit-resources.json
// module id = 571
// module chunks = 231608221292675